<template>
  <v-dialog :value="value" persistent max-width="750" @click:outside="closeDialog()">
    <v-card color="fill">
      <v-container class="shipperCon">
        <v-card-title class="my-0 py-0 pt-0 heading-6">
          <v-row justify="space-between" class="my-2">
            <v-col class="ma-0 pa-0 pb-4" align="start">
              <div class="text-no-wrap">
                Select Export Details
              </div>
            </v-col>
            <v-col class="pa-0 ma-0 pr-4" align="end">
              <v-btn icon @click="closeDialog()">
                <v-icon dense>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-row no-gutters>
          <v-col
            v-for="(detail, index) in detailSelectionList"
            :key="index"
            cols="3">
            <v-checkbox
              v-model="details"
              :value="detail"
              :label="detail.label"
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-row justify="end" class="mb-2 mr-2">
          <v-btn
            color="primary"
            :disabled="details.length === 0"
            @click="exportItems">
            Export
            <v-icon class="pl-2 pt-0" size="large">
              mdi-download
            </v-icon>
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

export default {
  name: 'ExportDetailsModal',
  props: {
    value: Boolean,
    isRetailer: Boolean,
    selectedItemDetails: Array
  },
  data () {
    return {
      details: []
    }
  },
  mounted() {
    if (this.selectedItemDetails && this.selectedItemDetails.length > 0) {
      this.details = this.selectedItemDetails
    }
  },
  watch: {
    details() {
      this.$emit('update:selectedItemDetails', this.details)
      localStorage.setItem('selectedItemDetails', JSON.stringify(this.details))
    }
  },
  computed: {
    detailSelectionList () {
      return [
        {
          id: 'source',
          label: 'Source',
          order: 1,
          show: true
        },
        {
          id: 'item_id',
          label: 'Item Id',
          order: 2,
          show: true
        },
        {
          id: 'description',
          label: 'Item Description',
          order: 3,
          show: true
        },
        { 
          id: 'upc',
          label: 'Item UPC',
          order: 4,
          show: true
        },
        {
          id: 'vendor_id',
          label: 'Vendor Id',
          order: 5,
          show: !this.isRetailer
        },
        {
          id: 'vendor_name',
          label: 'Vendor Name',
          order: 6,
          show: !this.isRetailer
        },
        {
          id: 'department',
          label: 'Department',
          order: 7,
          show: true
        },
        {
          id: 'category',
          label: 'Category',
          order: 8,
          show: true
        },
        {
          id: 'subcategory',
          label: 'SubCategory',
          order: 9,
          show: true
        },
        {
          id: 'qty_per_case',
          label: 'Qty Per Case',
          order: 10,
          show: true
        },
        {
          id: 'weight',
          label: 'Weight',
          order: 11,
          show: this.$auth.tenant === 'jbg'
        },
        {
          id: 'cube',
          label: 'Cube',
          order: 12,
          show: this.$auth.tenant === 'jbg'
        },
        {
          id: 'pack_size',
          label: 'Pack Size',
          order: 13,
          show: true
        }
      ].filter(d => d.show)
    }
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialog')
    },
    exportItems() {
      this.$emit('exportItems')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ExportDetailsModal.vue